import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  AGENT_NAMES,
  ATV_STATUS_LIST,
  BIKE_PRODUCTS,
  GUEST_NAMES,
} from "pages/transaksi/booking/components/Constants";
import { getRandomNum } from "../utils/utils";
import { getRequest, postRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";

// Membuat context untuk loading
const LogPhotographerContext = createContext();

// Provider untuk context loading
export const LogPhotographerProvider = ({ children }) => {
  const [logPhotographer, setLogPhotographer] = useState({
    data: [],
    loading: false,
    pagination: null,
    error: null,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
    filters: {
      photographer_id: "",
    },
  });

  const buildFilterString = (filters) => {
    const filterEntries = Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `filter[${key}]=${value}`);
    return filterEntries.join("&");
  };

  const updateFilter = (key, value) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [key]: value,
      },
    }));
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      if (e.target.value.trim() === "") {
        setFilterOptions((prevState) => ({
          ...prevState,
          search: "",
        }));
      } else {
        setFilterOptions((prevState) => ({
          ...prevState,
          search: e.target.value,
        }));
      }
    }
  };

  const fetchLogPhotographer = useCallback(async (photographerId) => {
    setLogPhotographer((prevState) => ({
      ...prevState,
      loading: true,
    }));

    if (!photographerId) {
      console.warn("Photographer ID is missing. Skipping API call.");
      return;
    }

    const queryStringWithFilter = buildQueryString({
      limit: 200,
      orderBy: "created_at",
      sort: "desc",
      "filter[status]": "confirmed,played,finished",
    });

    try {
      const response = await getRequest(`/reservation${queryStringWithFilter}`);

      if (response.success) {
        setLogPhotographer({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });
      }
    } catch (error) {
      setLogPhotographer((prevState) => ({
        ...prevState,
        error: "Failed to fetch log photographer activity",
        loading: false,
      }));
      console.error("Error fetching log photographer activities:", error);
    }
  }, []);

  useEffect(() => {
    fetchLogPhotographer();
  }, [filterOptions.filters.photographer_id]); // Pastikan ID menjadi trigger

  return (
    <LogPhotographerContext.Provider
      value={{
        logPhotographer,
        filterOptions,
        fetchLogPhotographer,
      }}
    >
      {children}
    </LogPhotographerContext.Provider>
  );
};

// Hook untuk mengakses context loading
export const useLogPhotographer = () => {
  const context = useContext(LogPhotographerContext);
  if (!context) {
    throw new Error("useLogPhotographer must be used within a LogPhotographerProvider");
  }
  return context;
};
